import React, { useState } from 'react';
import { PaginationWrapper } from '../../../../gui/controls/PaginationWrapper';
import { Table } from '../../../../gui/layout/Table';
import { StyledDepartments } from './Style';
import { Pagination as PaginationControl } from '../../../../gui/layout/Pagination';
import { Row } from '../../../../gui/layout/Row';
import { MainButton } from '../../../../gui/input/MainButton';
import { SearchBar } from '../../../../gui/input/SearchBar';
import { RightPanelModal } from '../../../../gui/layout/RightPanelModal';
import { FormGroup } from '../../../../gui/input/Form(old)/FormGroup';
import withActionPageLoader from '../../../../hoc/withActionPageLoader';
import { formatDate } from '../../../../../utils/dataManipulation/formatDate';
import { ButtonLoadWrapper } from '../../../../gui/input/Button/ButtonLoadWrapper';

import { changeDepartmentStatus, getDepartments, makeNewDepartment, deleteDepartment, editDepartment} from './actions';
import { DefaultItem, DropdownSelect, Item } from '../../../../gui/input/Select/DropdownSelect';
import { statusIcon } from '../../../../../App/theme/icons';
import { H1 } from '../../../../gui/elements/H1';
import { Form, BooleanWrapper, TextField, SubmitWrapper, SelectField } from '../../../../gui/input/Form';
import { ToggleSwitch } from '../../../../gui/input/ToggleSwitch';
import { SortControl, SortWrapper } from '../../../../gui/controls/SortWrapper';
import { TableSortArrows } from '../../../../gui/layout/Table/TableSortArrows';
import { FilterWrapper } from '../../../../gui/controls/FilterWrapper';
import { DropdownItem } from '../../../../gui/input/Select/Style';

export const Departments = withActionPageLoader(getDepartments, ({ loadedPageData, reloadPageData }) => {
  const [pageData, setPageData] = useState(loadedPageData);
  const [viewNewDepartmentModal, setViewNewDepartmentModal] = useState(false);
  const [actionType, setActionType] = useState({type: 'Add', statusCode:"ACTIVE", name: '', id:null});

  const [Status, setStatus] = useState(false);
  const [filters, setFilters] = useState({ statusCode: null, name: () => true});

  const onStatusChangeClick = async (_id, statusCode) => {
    try {
      await changeDepartmentStatus(_id, statusCode);

      for (let i = 0; i < pageData.length; i++) {
        if (pageData[i]._id === _id) {
          //await new Promise((resolve) => setTimeout(resolve, 1500))
          let newPageData = [...pageData];
          newPageData[i].statusCode = statusCode;
          setPageData(newPageData);
          break;
        }
      }
    } catch (err) {
      console.log(err);
      alert('failed to update status');
    }
  };

  const onNewDepartmentSubmit = async (values) => {
    try {
      if(actionType.type==="Add")
      {
        await makeNewDepartment(values)
        setViewNewDepartmentModal(false);
        reloadPageData();
      }
      else
      {
        await editDepartment(values, actionType.id)
        setViewNewDepartmentModal(false);
        reloadPageData();
      }
      
    } catch (err) {
      console.log(err);
      alert('Failed to create new department');
    }
  };

  const onStatusChanged = (newStatus) => {
    setFilters((prevState) => ({ ...prevState, statusCode: newStatus }));
  };

  const onSearchChange = (searchFilter) => {
    setFilters((prevState) => {
      let newFilterFunc = null;
      searchFilter = searchFilter.trim();

      if (searchFilter.length === 0) {
        newFilterFunc = (value) => true;
      } else {
        newFilterFunc = (value) => value.name.toLowerCase().startsWith(searchFilter);
      }

      return { ...prevState, name: newFilterFunc };
    });
  };

  const onDeleteClick = async (departmentId) => {
    try
    {
      await deleteDepartment(departmentId)
      for (let i = 0; i < pageData.length; i++) {
        if (pageData[i]._id === departmentId) {
          let newPageData = [...pageData];
          newPageData.splice(i,1)
          setPageData(newPageData);
          break;
        }
      }
    }
    catch(err)
    {
      console.log("ERROR",err)
      alert('Failed to delete department.')
    }
  }

  return (
    <StyledDepartments>
      <Row justify="space-between" margin="0rem 0">
        <H1>Departments</H1>
        <MainButton onClick={() => setViewNewDepartmentModal(true)}>+ Department</MainButton>
      </Row>
      <Row justify="space-between" margin="2rem 0">
        <SearchBar onChange={onSearchChange}/>
        <DropdownSelect width="180px" type="all-status" HeaderStyle="fill" defaultValue={null} onChange={onStatusChanged}>
          <DefaultItem>{statusIcon}&nbsp;All Status</DefaultItem>
          <Item value={null}>{statusIcon}&nbsp;All Status</Item>
          <Item value="ACTIVE">{statusIcon}&nbsp;Active</Item>
          <Item value="INACTIVE">{statusIcon}&nbsp;Inactive</Item>
        </DropdownSelect>
      </Row>
      <FilterWrapper data={pageData} filters={filters}>
        <SortWrapper>
          <PaginationWrapper dataProp="data" PaginationControl={PaginationControl} dataName="departments">
            <Table
              colHeaders={[
                <>Department<SortControl sortKey="name"><TableSortArrows/></SortControl></>,
                <>Created Date<SortControl sortKey="createdAt"><TableSortArrows/></SortControl></>,
                <>Created By<SortControl sortKey="createdBy"><TableSortArrows/></SortControl></>,
                <>Status<SortControl sortKey="statusCode"><TableSortArrows/></SortControl></>,
                'Action'
              ]}
              colCustomSize="3fr 3fr 3fr 2fr 5fr"
              LineItem={({ row }) => (
                <tr>
                  <td>{row.name}</td>
                  <td>{formatDate(row.createdAt)}</td>
                  <td>{row.createdBy}</td>
                  <td className={`status-buttons ${row.statusCode === "ACTIVE" ? 'green-status' : 'red-status'}`}>{row.statusCode === "ACTIVE" ? 'Active' : 'Inactive'} </td>
                  <td>
                    <Row margin="0">
                      <MainButton onClick={()=>{setViewNewDepartmentModal(true); setActionType({type:'Edit', name:row.name, statusCode: row.statusCode, id: row._id})}} type="empty" padding="1rem" color="#418EEB">
                        View & Edit <i className="fa-solid fa-pen-to-square"></i>
                      </MainButton>
                      &nbsp;&nbsp;&nbsp;
                      {/* {row.statusCode === "ACTIVE" && ( */}
                        <ButtonLoadWrapper spinnerSize="2.5rem" type="empty" padding="1rem" color="#861724" onClick={() => onDeleteClick(row._id)}>
                          Delete 
                          {/* <i className="fa-solid fa-trash"></i> */}
                          <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.25092 6.83879C3.25092 6.42458 2.91513 6.08879 2.50092 6.08879C2.0867 6.08879 1.75092 6.42458 1.75092 6.83879H3.25092ZM14.2509 6.83879C14.2509 6.42458 13.9151 6.08879 13.5009 6.08879C13.0867 6.08879 12.7509 6.42458 12.7509 6.83879H14.2509ZM10.5843 7.82159C10.5843 7.40738 10.2485 7.07159 9.83431 7.07159C9.4201 7.07159 9.08431 7.40738 9.08431 7.82159H10.5843ZM9.08431 14.6966C9.08431 15.1108 9.4201 15.4466 9.83431 15.4466C10.2485 15.4466 10.5843 15.1108 10.5843 14.6966H9.08431ZM6.91689 7.82159C6.91689 7.40738 6.5811 7.07159 6.16689 7.07159C5.75268 7.07159 5.41689 7.40738 5.41689 7.82159H6.91689ZM5.41689 14.6966C5.41689 15.1108 5.75268 15.4466 6.16689 15.4466C6.5811 15.4466 6.91689 15.1108 6.91689 14.6966H5.41689ZM1.12549 3.14234C0.711275 3.14234 0.375488 3.47812 0.375488 3.89234C0.375488 4.30655 0.711275 4.64234 1.12549 4.64234V3.14234ZM14.8755 4.64234C15.2897 4.64234 15.6255 4.30655 15.6255 3.89234C15.6255 3.47812 15.2897 3.14234 14.8755 3.14234V4.64234ZM3.61797 3.66992C3.49492 4.06543 3.7158 4.48581 4.11131 4.60886C4.50683 4.73191 4.92721 4.51103 5.05025 4.11552L3.61797 3.66992ZM4.83278 2.28986L5.54892 2.51266L5.54897 2.5125L4.83278 2.28986ZM6.57261 0.946291L6.57242 1.69629H6.57261V0.946291ZM9.42894 0.946291V1.69629L9.42994 1.69629L9.42894 0.946291ZM11.1706 2.28986L11.887 2.06781L11.8868 2.06723L11.1706 2.28986ZM10.9511 4.11477C11.0737 4.51041 11.4939 4.73173 11.8895 4.60909C12.2851 4.48646 12.5065 4.06631 12.3838 3.67067L10.9511 4.11477ZM1.75092 6.83879V16.6602H3.25092V6.83879H1.75092ZM1.75092 16.6602C1.75092 18.1097 2.85962 19.3745 4.33425 19.3745V17.8745C3.78384 17.8745 3.25092 17.3804 3.25092 16.6602H1.75092ZM4.33425 19.3745H11.6676V17.8745H4.33425V19.3745ZM11.6676 19.3745C13.1422 19.3745 14.2509 18.1097 14.2509 16.6602H12.7509C12.7509 17.3804 12.218 17.8745 11.6676 17.8745V19.3745ZM14.2509 16.6602V6.83879H12.7509V16.6602H14.2509ZM9.08431 7.82159V14.6966H10.5843V7.82159H9.08431ZM5.41689 7.82159V14.6966H6.91689V7.82159H5.41689ZM1.12549 4.64234H14.8755V3.14234H1.12549V4.64234ZM5.05025 4.11552L5.54892 2.51266L4.11664 2.06706L3.61797 3.66992L5.05025 4.11552ZM5.54897 2.5125C5.70953 1.99601 6.13963 1.69618 6.57242 1.69629L6.5728 0.196291C5.4267 0.195997 4.45496 0.978731 4.11659 2.06723L5.54897 2.5125ZM6.57261 1.69629H9.42894V0.196291H6.57261V1.69629ZM9.42994 1.69629C9.86307 1.69572 10.2937 1.99556 10.4544 2.5125L11.8868 2.06723C11.5481 0.977803 10.5751 0.194769 9.42795 0.196291L9.42994 1.69629ZM10.4542 2.51192L10.9511 4.11477L12.3838 3.67067L11.887 2.06781L10.4542 2.51192Z" fill="#861724"/>
</svg>

                        </ButtonLoadWrapper>
                      {/* )
                      } */}
                     
                    </Row>
                  </td>
                </tr>
              )}
            />
          </PaginationWrapper>
        </SortWrapper>
      </FilterWrapper>

      <RightPanelModal shouldShow={viewNewDepartmentModal} onRequestClose={() => {setViewNewDepartmentModal(false);setActionType({type:'Add', statusCode:"ACTIVE"})}} >
        <Form onSubmit={onNewDepartmentSubmit}>
          <h3>{actionType.type} Department</h3>
          <FormGroup margin="0">
            <TextField name="name" label="Name" defaultValue={actionType.name} />
          </FormGroup>
         
         
          {/*<FormGroup margin="0">
            <SelectField margin="0" name="users"  
              label={<div>Users</div>} 
              placeholder="Select users"
              defaultValue={loadedPageData.users || null}
            >
          <DropdownSelect type='grey'>
            <DefaultItem>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.414 20.586L18.337 15.509C19.386 13.928 20 12.035 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C12.035 20 13.928 19.386 15.509 18.337L20.586 23.414C21.366 24.195 22.634 24.195 23.414 23.414C24.195 22.633 24.195 21.367 23.414 20.586ZM3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17C6.14 17 3 13.86 3 10Z" fill="#A5A5A5"/>
              </svg>
              {loadedPageData.users || 'Select users'}</DefaultItem>

              <DropdownItem value={1}>
                      1
              </DropdownItem>

          </DropdownSelect>
        </SelectField>
          </FormGroup>
          <FormGroup margin="0">
            <SelectField margin="0" name="users"  
              label={<div>Sub Department</div>} 
              placeholder="Select sub department"
              defaultValue={loadedPageData.users || null}
            >
          <DropdownSelect type='grey'>
            <DefaultItem>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.414 20.586L18.337 15.509C19.386 13.928 20 12.035 20 10C20 4.486 15.514 0 10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C12.035 20 13.928 19.386 15.509 18.337L20.586 23.414C21.366 24.195 22.634 24.195 23.414 23.414C24.195 22.633 24.195 21.367 23.414 20.586ZM3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17C6.14 17 3 13.86 3 10Z" fill="#A5A5A5"/>
              </svg>
 {loadedPageData.users || 'Select sub department'}</DefaultItem>

              <DropdownItem value={1}>
                      1
              </DropdownItem>

          </DropdownSelect>
        </SelectField>
        </FormGroup>*/}
{/* 
            <DropdownSelect type='grey' name="subdepartment" label="Sub Department" defaultValue={actionType.name}>
            <Item>1</Item>
              <Item>2</Item>
            </DropdownSelect> */}

          <FormGroup margin="0.5rem 0">


            <BooleanWrapper name="isActive" label="Status" defaultValue={actionType.statusCode === "ACTIVE"}>
              <ToggleSwitch defaultValue={actionType.statusCode === "ACTIVE"}/>
            </BooleanWrapper>
          </FormGroup>
          <FormGroup margin="0.5rem">
            <SubmitWrapper>
              <ButtonLoadWrapper marginLeft="auto" spinnerSize="2.5rem">
                Save {actionType.type === 'Edit' ? 'modifications' : 'department'} 
              </ButtonLoadWrapper>
            </SubmitWrapper>
          </FormGroup>
        </Form>
      </RightPanelModal>

    </StyledDepartments>
  );
});
